import { styled } from "@mui/material/styles";

export const Container = styled("div")(() => ({}));

export const Title = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));
